import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormGroup, FormControl, ControlLabel} from 'react-bootstrap';

class InputAdvanced extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.forceReset || ((JSON.stringify(this.props) !== JSON.stringify(prevProps)) && this.props.reset)) {
      this.resetFilter(this.props.value);
    }
  }

  handleBlur = event => {
    this.props.onBlur(event.target.name, event.target.value, event.target.dataset.index, this._input);
  };

  handleChange = event => {
    this.props.onChange(event.target.name, event.target.value);
  };

  resetFilter(value) {
    this._input.value = value || '';
  }

  render() {
    const {
      label, labelSeparator, name, type, value, placeholder, placeholderFocus, maxLength, index, min, disabled, autoComplete, optional,
      onKeyDown, onFocus, onClear, inputClassName, pattern, labelClassName, required
    } = this.props;
    const labelHtml = (label === '') ? null :
      <ControlLabel className={labelClassName}>{label}{labelSeparator}</ControlLabel>;
    return (
      <FormGroup className={optional ? 'optional' : null}>
        {labelHtml}
        <FormControl
          autoComplete={autoComplete}
          className={inputClassName}
          data-index={index}
          data-placeholder-focus={placeholderFocus}
          defaultValue={value}
          disabled={disabled ? 'disabled' : null}
          inputRef={ref => {
            this._input = ref;
          }}
          maxLength={maxLength}
          min={min}
          name={name}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onFocus={event => onFocus(this._input)}
          onKeyDown={event => onKeyDown(event.keyCode, this._input)}
          pattern={pattern}
          placeholder={placeholder}
          required={required}
          type={type}
        />
        {onClear ? <i className="fas fa-times-circle" onClick={onClear}/> : null}
      </FormGroup>
    );
  }
}

InputAdvanced.propTypes = {
  autoComplete: PropTypes.string,
  disabled: PropTypes.bool,
  forceReset: PropTypes.bool,
  index: PropTypes.number,
  inputClassName: PropTypes.string,
  label: PropTypes.string.isRequired,
  labelSeparator: PropTypes.any,
  maxLength: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  optional: PropTypes.bool,
  pattern: PropTypes.string,
  placeholder: PropTypes.string,
  placeholderFocus: PropTypes.string,
  required: PropTypes.bool,
  reset: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

InputAdvanced.defaultProps = {
  autoComplete: 'nope',
  label: '',
  labelSeparator: ':',
  name: '',
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  onKeyDown: () => {},
  pattern: null,
  placeholder: null,
  type: 'text',
  value: '',
};

export default InputAdvanced;
